/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */

import { apiSlice } from "./apiSlice";
import TagSerializer from "./serializers/TagSerializer";
import { Tag } from "../../app/types/Tag";

const tagSerializer = new TagSerializer();

const tagApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getTags: build.query<Tag[], void>({
            query: () => ({ url: `/NI-api/tags` }),
            transformResponse: (response: any) => tagSerializer.deserializeList(response),
            providesTags: ["Tag"],
        }),
        createTag: build.mutation<void, Tag>({
            query: (tag) => ({ url: `/NI-api/tags`, method: "POST", data: tagSerializer.serialize(tag) }),
            invalidatesTags: ["Tag"],
        }),
    }),
    overrideExisting: false,
});

export const { useGetTagsQuery, useCreateTagMutation } = tagApi;
